const config = {
  ssoUrl: 'https://web1.test.ezlogz.com/ezloadz',
};

export default config;
